// extracted by mini-css-extract-plugin
export var statItem = "_cm-1";
export var statsRow = "_cm-0";